<template>
    <v-popover
        :trigger="trigger"
        :offset="offset"
        :placement="placement"
        :boundariesElement="boundary"
        popoverClass="z-50"
        popoverBaseClass=""
        popoverWrapperClass=""
        popoverArrowClass=""
        popoverInnerClass=""
    >
        <span>
            <slot />
        </span>

        <template slot="popover">
            <slot name="content" />
        </template>
    </v-popover>
</template>

<script>
export default {
    props: {
        offset: {
            type: [Number, String],
            default: 3,
        },

        trigger: {
            default: 'hover',
            validator: val => ['click', 'hover'].includes(val),
        },

        placement: {
            type: String,
            default: 'top',
        },

        boundary: {
            type: String,
            default: 'window',
        }
    }
}
</script>
